import { useParams } from 'react-router-dom';
import FacebookCommentsPanel from '../../../components/FacebookCommentsPanel';

export default function CommentsRoute() {
  const { botId } = useParams<{ botId: string }>();
  if (!botId) return null;
  return <FacebookCommentsPanel botId={botId} />;
}
